import React from 'react';
import { observer } from 'mobx-react';
import { ReceivingHistoryLogListTemplate } from 'themes/modules/receiving/pages';
import { ReceivingHistoryLogViewStore } from 'modules/receiving/stores';
import { setCurrentView } from 'core/utils';

@setCurrentView(rootStore => new ReceivingHistoryLogViewStore(rootStore), 'receivingHistoryLogViewStore')
@observer
class ReceivingHistoryLogList extends React.Component {
	constructor(props) {
		super(props);
	}
	render() {
		return <ReceivingHistoryLogListTemplate {...this.props} headerCell={[]} />;
	}
}

export default ReceivingHistoryLogList;



// WEBPACK FOOTER //
// ./src/themes/default/modules/receiving/pages/ReceivingHistoryLogList.jsx